import EmblaCarousel from "embla-carousel"
import Fade from "embla-carousel-fade"
import Autoplay from "embla-carousel-autoplay"
import e from "jquery-datetimepicker"

export default class ProgramHero {
  constructor() {
    this.hero = document.querySelector(".program-hero")
    this.slider = document.querySelector(".program-hero .embla")
    this.text = document.querySelector(".program-hero__dynamic-text")
    this.textItem = document.querySelectorAll(".program-hero__text-item")

    if (!this.hero || !this.slider) return

    this.initSlider()
  }

  initSlider() {
    const emblaNode = this.hero.querySelector(".embla")
    const viewportNode = emblaNode.querySelector(".embla__viewport")

    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)")

    const emblaApi = EmblaCarousel(viewportNode, { loop: true, duration: 30, watchDrag: false }, [
      Fade(),
      Autoplay({ playOnInit: !mediaQuery.matches, delay: 3000 }),
    ])

    emblaApi.on("init", () => {
      const currentWidth = document.querySelector(".program-hero__text-item.active").clientWidth
      this.text.style.width = `${currentWidth}px`

      this.textItem.forEach((item) => {
        const text = item.textContent
        const splitText = text.split("")
        item.innerHTML = ""

        for (let i = 0; i < splitText.length; i++) {
          const tag = document.createElement("span")
          tag.textContent = splitText[i]
          item.appendChild(tag)
        }
      })
    })

    emblaApi.on("resize", () => {
      this.text.style.width = "auto"
      const currentWidth = document.querySelector(".program-hero__text-item.active").clientWidth
      this.text.style.width = `${currentWidth}px`
    })

    emblaApi.on("select", () => {
      const toSlide = emblaApi.selectedScrollSnap()

      this.textItem.forEach((item) => {
        item.classList.remove("active")
        item.querySelectorAll("span").forEach((span) => {
          span.style.opacity = 0
        })
      })

      const nextText = this.textItem[toSlide]
      nextText.classList.add("active")
      const currentWidth = document.querySelector(".program-hero__text-item.active").clientWidth
      this.text.style.width = "auto"
      const nextWidth = nextText.clientWidth
      this.text.style.width = `${currentWidth}px`

      setTimeout(() => {
        this.text.style.width = `${nextWidth}px`
      }, 10)

      setTimeout(() => {
        const timer = 400
        let lettersShown = 0
        const interval = setInterval(() => {
          nextText.querySelectorAll("span")[lettersShown].style.opacity = 1
          lettersShown++
          if (lettersShown === nextText.textContent.length) {
            clearAnimation()
          }
        }, timer / nextText.textContent.length)
        function clearAnimation() {
          clearInterval(interval)
        }
      }, 500)
    })

    this.playPause = document.querySelector(".program-hero .play-pause")
    this.playPauseIcon = this.playPause.querySelector(".play-pause__icon")
    this.playPauseText = this.playPause.querySelector(".play-pause__text")

    if (!mediaQuery.matches) {
      this.playPauseIcon.classList.remove("play-pause__icon--play")
      this.playPauseText.textContent = "Pause Video"
    }

    this.playPause.addEventListener("click", () => {
      if (emblaApi.plugins().autoplay.isPlaying()) {
        emblaApi.plugins().autoplay.stop()
        this.playPauseIcon.classList.remove("play-pause__icon--pause")
        this.playPauseIcon.classList.add("play-pause__icon--play")
        this.playPauseText.textContent = "Play Animation"
      } else {
        emblaApi.plugins().autoplay.play()
        this.playPauseIcon.classList.remove("play-pause__icon--play")
        this.playPauseIcon.classList.add("play-pause__icon--pause")
        this.playPauseText.textContent = "Pause Animation"
      }
    })
  }
}
